<template>
  <div>
    <chart :options="option"></chart>
  </div>
</template>
<script>
export default {
  data() {
    return {
      option: {
        title: {
          text: '平台前十文章点击量',
          textStyle: {
            color: '#008B8B'
          }
        },
        color: ['#A5D1F0'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '直接访问',
            type: 'bar',
            barWidth: '60%',
            data: [10, 52, 200, 334, 390, 330, 220]
          }
        ]
      }
    };
  }
};
</script>
<style lang="stylus" scoped>
.echarts {
  width 100%
}
</style>



// WEBPACK FOOTER //
// src/common/component/columnarChart.vue